"use strict";

exports.__esModule = true;

exports.default = function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/utils/determineTheme.js
// module id = 225
// module chunks = 168707334958949